import { FC } from "react";

import { findPageGroupIndexOfStudentUser } from "../groups/helpers";

import { InteractionMode } from "components/server-types";
import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { ORDER_BY_CREATED, useCustomOrdered } from "mds/hooks/use-ordered";
import { useAppSelector } from "store";
import { useCapabilities } from "store/capability-hooks";
import {
  pageSelectors,
  selectCurrentSectionUserId,
  selectPageGroupsWithUsersByPageId,
} from "store/selectors";
import { useObjectSelector } from "store/store-hooks";

interface GroupNotAssignedBannerProps {
  pageId: string;
}

export const GroupNotAssignedBanner: FC<GroupNotAssignedBannerProps> = ({ pageId }) => {
  const { canParticipateInSection } = useCapabilities();
  const page = useObjectSelector((s) => pageSelectors.selectById(s, pageId), ["interaction_mode"]);
  const sectionUserId = useAppSelector(selectCurrentSectionUserId);
  // TODO: pageGroups is only used to check findPageGroupIndexOfStudentUser === -1 (order doesn't matter).
  // Add a selector that returns that boolean so this banner doesn't subscribe to the group objects.
  const pageGroups = useCustomOrdered(
    useAppSelector((s) => selectPageGroupsWithUsersByPageId(s, pageId)),
    ORDER_BY_CREATED,
  );

  const showCurrentStudentNotInGroupBanner =
    canParticipateInSection &&
    page?.interaction_mode === InteractionMode.ASSIGN_STUDENTS &&
    findPageGroupIndexOfStudentUser(pageGroups, sectionUserId) === -1;

  if (!showCurrentStudentNotInGroupBanner) {
    return null;
  }

  return (
    <Banner className="group-card" kind="warning">
      {t("group_configuration_card.group_not_assigned")}
    </Banner>
  );
};
